import React, { useState, useEffect} from "react";
import { useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import { isMobileOrTablet } from "../Utils";
import { Link } from "react-router-dom";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";

import "./NavigationBar.css";

export default function NavigationBar() {
  const [navbar, setNavbar] = useState(false);
  const [expanded, setExpanded] = useState(false);
  
  const [showRigVedQuotes, setShowRigVedQuotes] = useState(false);
  const isMobileOrTabletDevice = isMobileOrTablet();
    const location = useLocation();
  const imgCDNURL = process.env.REACT_APP_CDN;

  const isEventsPage = location.pathname === "/events/sweetheart2025" ||
    location.pathname === "/events/sweetheart2025/";

  useEffect(() => {
    let prevScrollPos = window.scrollY;

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const menuNavbar = document.getElementById("menuNavbar");
      const isDesktop = !isMobileOrTabletDevice;

      if (currentScrollPos === 0) {
        menuNavbar.classList.remove("navbarTransition");
        setNavbar(false);
      } else {
        if (prevScrollPos > currentScrollPos) {
          setNavbar(true);
        } else {
          if (isDesktop) {
            setNavbar(true);
          } else {
            setNavbar(false);
            setShowRigVedQuotes(false);
            menuNavbar.classList.add("navbarTransition");
          }
        }
      }

      setExpanded(false);
      prevScrollPos = currentScrollPos;
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobileOrTabletDevice]);

  const handleMenuClick = () => {
    setExpanded(false);
    setNavbar(false);
  };

  const toggleQuotesVisibility = () => {
    setShowRigVedQuotes((prevState) => !prevState);
  };



  return (
    <>
      <div>
        <Navbar
          id="menuNavbar"
          collapseOnSelect
          expanded={expanded}
          onToggle={() => setExpanded(!expanded)}
          onSelect={() => setExpanded(false)}
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={`navbar ${navbar ? "active" : ""} ${isEventsPage ? "events-navbar" : ""
            }`}
        >
          <Container className="navbar-container">
            <Navbar.Brand className="navbrand-logo">
              <div className="d-flex">
                <div>
                  <Link to="/" onClick={() => setExpanded(false)}>
                    <img
                      src={imgCDNURL + "evolutionai/images/evolutionai.webp"}
                      alt="Evolution AI logo"
                      width="494px"
                      height="184px"
                      className={`main_logo img-fluid ${isEventsPage ? "events-main-eai-logo" : ""
                        }`}
                    />
                  </Link>
                </div>
              </div>
            </Navbar.Brand>

            <div className="desktopaccesibility">
              <UserWayAccessibilityMenu color="white" width={30} height={30} />
            </div>
          </Container>
        </Navbar>
      </div>
      <Container>
       
      </Container>

    </>
  );
}